import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchDemandRequest extends BaseModel {
  static override constructorName = 'ResearchDemandRequest'

  fio: string = ''
  'company_name': string = ''
  position: string = ''
  phone: string = ''
  email: string = ''
  'project_description': string = ''
  'privacy_accepted': boolean = false
  'terms_accepted': boolean = false
  'policy_accepted': boolean = false
  'marketing_accepted': boolean = false
  'research_demand_card_id': number | null = null
  status: string = ''
  'created_at': string = ''
  'updated_at': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchDemandRequest)
